import React from "react";
import BlogItemContainer from "../containers/blog/blog-item";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import BlogData from "../data/blog.json";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const BlogPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="SpeakNest – Pricing" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="Pricing"
                        excerpt="Affordable Plans for Every Learner <br />
                        Choose the pricing plan that suits you best."
                        image="./images/blog/banner.png"
                    />
                    <BlogItemContainer />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default BlogPage;
